import type { FlowId, SelfServiceData } from '../types';

export const DL_CASE_VALUES = ['first_time', 'renewal', 'replacement', 'upgrade', 'exchange_foreign'] as const;
export type DlCaseType = NonNullable<SelfServiceData['dlCaseType']>;
export const DL_CASE_TYPE_VALUES: readonly DlCaseType[] = DL_CASE_VALUES;
export const isDlCaseType = (value: unknown): value is DlCaseType => typeof value === 'string' && DL_CASE_TYPE_VALUES.includes(value as DlCaseType);

export const DL_CASE_TYPE_OPTIONS = [
  { value: DL_CASE_VALUES[0], label: 'Førstegangskørekort' },
  { value: DL_CASE_VALUES[1], label: 'Fornyelse' },
  { value: DL_CASE_VALUES[2], label: 'Erstatning (bortkommet/beskadiget)' },
  { value: DL_CASE_VALUES[3], label: 'Udvidelse/ny kategori' },
  { value: DL_CASE_VALUES[4], label: 'Ombytning af udenlandsk kørekort' }
] as const satisfies ReadonlyArray<{ value: DlCaseType; label: string }>;

export const DL_CASE_TYPE_LABELS = DL_CASE_TYPE_OPTIONS.reduce<Record<DlCaseType, string>>((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {} as Record<DlCaseType, string>);

export const getDlCaseTypeLabel = (value?: DlCaseType | null): string => (value ? DL_CASE_TYPE_LABELS[value] ?? value : '');

export const DL_CATEGORY_VALUES = ['AM', 'A', 'B', 'C', 'D', 'BE', 'CE', 'DE'] as const;
export type DlCategory = NonNullable<SelfServiceData['dlCategory']>;
export const DL_CATEGORY_OPTIONS = [
  { value: DL_CATEGORY_VALUES[0], label: 'AM (knallert)' },
  { value: DL_CATEGORY_VALUES[1], label: 'A (motorcykel)' },
  { value: DL_CATEGORY_VALUES[2], label: 'B (personbil)' },
  { value: DL_CATEGORY_VALUES[3], label: 'C (lastbil)' },
  { value: DL_CATEGORY_VALUES[4], label: 'D (bus)' },
  { value: DL_CATEGORY_VALUES[5], label: 'BE (bil med stor trailer)' },
  { value: DL_CATEGORY_VALUES[6], label: 'CE (lastbil med påhæng)' },
  { value: DL_CATEGORY_VALUES[7], label: 'DE (bus med påhæng)' }
] as const satisfies ReadonlyArray<{ value: DlCategory; label: string }>;

export const DL_LIGHT_CATEGORIES = new Set<DlCategory>(['AM', 'A', 'B']);
export const DL_HEAVY_CATEGORIES = new Set<DlCategory>(['C', 'D', 'CE', 'DE']);
export const isDlCategory = (value: unknown): value is DlCategory => typeof value === 'string' && DL_CATEGORY_VALUES.includes(value as DlCategory);

export type DlCustodyType = NonNullable<SelfServiceData['dlCustodyType']>;
export const DL_CUSTODY_TYPES: ReadonlyArray<{ value: DlCustodyType; label: string }> = [
  { value: 'ene', label: 'Forælder med eneforældremyndighed' },
  { value: 'med', label: 'Begge forældre har fælles forældremyndighed' }
];

export const DRIVER_FLOW_ID: FlowId = 'koerekort';

export const DRIVER_CONSENT_FLOW_ID: FlowId = 'koerekort_samtykke';

export const isDlCustodyType = (value: unknown): value is DlCustodyType => typeof value === 'string' && (value === 'ene' || value === 'med');
